"use client";

import React, { Suspense } from "react";
import { cn } from "@/lib/utils";
import FormattedDate from "@/components/global/countdown/FormattedDate";
import { useCountdown } from "@/lib/utilHooks";
import { useEffect } from "react";
import de from "date-fns/esm/locale/de/index.js";

export default function Countdown({
  dateTimeString,
  className,
  lang = "de",
  useGradientText = false,
  useBebasFont = false,
}: {
  dateTimeString: string;
  className?: string;
  lang: "de" | "en";
  useGradientText?: boolean;
  useBebasFont?: boolean;
}) {
  const { days, hours, minutes, seconds } = useCountdown(dateTimeString);

  const daysText = lang === "de" ? "tage" : "days";
  const hoursText = lang === "de" ? "STUNDEN" : "hours";
  const minutesText = lang === "de" ? "MINUTEN" : "minutes";
  const secondsText = lang === "de" ? "SEKUNDEN" : "seconds";

  useEffect(() => {
    console.log("dateTimeString", dateTimeString);
  }, [dateTimeString]);

  return (
    <div className="flex flex-col justify-center items-center">
      <div className={cn("grid grid-cols-4 w-full")}>
        {/* TAGE */}
        <div
          className={cn(
            "countdownUnitItem flex flex-col justify-center items-center border-r py-[2rem] lg:py-[3.44rem]",
            "border-[#103037]/10",
          )}
        >
          <div className="flex flex-col justify-center items-center">
            <h2
              className={cn(
                useBebasFont
                  ? "text-[8rem] lg:text-[12rem]"
                  : "text-[6rem] lg:text-[7.25rem]",
                "tracking-[normal] leading-[90%] font-normal",
                useGradientText
                  ? "bg-gradient-to-b from-white/10 from-[-19.76%] to-white to-[37.65%] bg-clip-text text-transparent"
                  : "text-white",
                useBebasFont && "font-bebas",
              )}
            >
              {days}
            </h2>
            <h6
              className={cn(
                "font-[500] text-[1.375rem] lg:text-[1.5rem] leading-[90%] uppercase",
                "text-white/70",
              )}
            >
              {daysText}
            </h6>
          </div>
        </div>
        {/* STUNDEN */}
        <div
          className={cn(
            "countdownUnitItem flex flex-col justify-center items-center border-r py-[2rem] lg:py-[3.44rem]",
            "border-[#103037]/10",
          )}
        >
          <div className="flex flex-col justify-center items-center">
            <h2
              className={cn(
                useBebasFont
                  ? "text-[8rem] lg:text-[12rem]"
                  : "text-[6rem] lg:text-[7.25rem]",
                "tracking-[normal] leading-[90%] font-normal",
                useGradientText
                  ? "bg-gradient-to-b from-white/10 from-[-19.76%] to-white to-[37.65%] bg-clip-text text-transparent"
                  : "text-white",
                useBebasFont && "font-bebas",
              )}
            >
              {hours}
            </h2>
            <h6
              className={cn(
                "font-[500] text-[1.375rem] lg:text-[1.5rem] leading-[90%] uppercase",
                "text-white/70",
              )}
            >
              {hoursText}
            </h6>
          </div>
        </div>
        {/* MINUTEN */}
        <div
          className={cn(
            "countdownUnitItem flex flex-col justify-center items-center border-r py-[2rem] lg:py-[3.44rem]",
            "border-[#103037]/10",
          )}
        >
          <div className="flex flex-col justify-center items-center">
            <h2
              className={cn(
                useBebasFont
                  ? "text-[8rem] lg:text-[12rem]"
                  : "text-[6rem] lg:text-[7.25rem]",
                "tracking-[normal] leading-[90%] font-normal",
                useGradientText
                  ? "bg-gradient-to-b from-white/10 from-[-19.76%] to-white to-[37.65%] bg-clip-text text-transparent"
                  : "text-white",
                useBebasFont && "font-bebas",
              )}
            >
              {minutes}
            </h2>
            <h6
              className={cn(
                "font-[500] text-[1.375rem] lg:text-[1.5rem] leading-[90%] uppercase",
                "text-white/70",
              )}
            >
              {minutesText}
            </h6>
          </div>
        </div>
        {/* SEKUNDEN */}
        <div className="countdownUnitItem flex flex-col justify-center items-center py-[2rem] lg:py-[3.44rem]">
          <div className="flex flex-col justify-center items-center">
            <h2
              className={cn(
                useBebasFont
                  ? "text-[8rem] lg:text-[12rem]"
                  : "text-[6rem] lg:text-[7.25rem]",
                "tracking-[normal] leading-[90%] font-normal",
                useGradientText
                  ? "bg-gradient-to-b from-white/10 from-[-19.76%] to-white to-[37.65%] bg-clip-text text-transparent"
                  : "text-white",
                useBebasFont && "font-bebas",
              )}
            >
              {seconds}
            </h2>
            <h6
              className={cn(
                "font-[500] text-[1.375rem] lg:text-[1.5rem] leading-[90%] uppercase",
                "text-white/70",
              )}
            >
              {secondsText}
            </h6>
          </div>
        </div>
      </div>
    </div>
  );
}
